import { Box, Paper, Typography } from '@mui/material'

import ToothGraphic6 from '@/assets/images/Tooth-graphic-6.svg'
import PieChart from '@/components/PieChart'
import { isNullorEmpty, isNullorEmptyArr } from '@/utils'

function AestheticModelPDF({ recipe }) {
  if (!isNullorEmpty(recipe, 'prep_advice')) return null

  return (
    <Paper
      id="download-page-0"
      elevation={0}
      sx={{
        backgroundColor: '#FFF',
        px: 5,
        py: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
        color: 'black',
      }}
    >
      <Box display="flex" alignItems="center" sx={{ height: '100%' }}>
        <Box display="flex" width="30%">
          <img
            src={ToothGraphic6}
            alt="ToothGraphic6"
            style={{ width: '200px', height: '330px' }}
          />
        </Box>

        <Box width="70%">
          <Box display="flex" alignItems="center" m={2}>
            <Typography variant="h5" sx={{ marginRight: 2, color: 'black' }}>
              Aesthetic Model:
            </Typography>
            {isNullorEmpty(
              recipe,
              'provided_input',
              'natural_die_material',
            ) && (
              <Box
                sx={{
                  backgroundColor: '#F44336',
                  borderRadius: '16px',
                  padding: '6px 12px',
                  color: 'black',
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                {recipe.provided_input.natural_die_material}
              </Box>
            )}
          </Box>

          <Box display="flex" justifyContent="center" gap={4} mt={2}>
            {isNullorEmptyArr(
              [recipe.prep_advice, 'prep_names_cervical'],
              [recipe.prep_advice, 'prep_ratios_cervical'],
            ) && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="120px"
              >
                <Typography variant="h6" fontWeight="bold" mb={1} color="black">
                  Cervical
                </Typography>
                <PieChart
                  labels={recipe.prep_advice.prep_names_cervical}
                  values={recipe.prep_advice.prep_ratios_cervical}
                />
              </Box>
            )}

            {/* Middle */}
            {isNullorEmptyArr(
              [recipe.prep_advice, 'prep_names_middle'],
              [recipe.prep_advice, 'prep_ratios_middle'],
            ) && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="120px"
              >
                <Typography variant="h6" fontWeight="bold" mb={1} color="black">
                  Middle
                </Typography>
                <PieChart
                  labels={recipe.prep_advice.prep_names_middle}
                  values={recipe.prep_advice.prep_ratios_middle}
                />
              </Box>
            )}

            {/* Incisal */}
            {isNullorEmptyArr(
              [recipe.prep_advice, 'prep_names_incisal'],
              [recipe.prep_advice, 'prep_ratios_incisal'],
            ) && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="120px"
              >
                <Typography variant="h6" fontWeight="bold" mb={1} color="black">
                  Incisal
                </Typography>
                <PieChart
                  labels={recipe.prep_advice.prep_names_incisal}
                  values={recipe.prep_advice.prep_ratios_incisal}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      {/* Divider */}
      <Box
        component="hr"
        sx={{
          backgroundColor: 'black',
          opacity: 1,
          margin: 0,
          border: 0,
          height: '1px',
        }}
      />
    </Paper>
  )
}

export default AestheticModelPDF
